import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { RecentProjects } from "@/components/RecentProjects";
import { TrustBadges } from "@/components/TrustBadges";
import { CallToActionSection } from "@/components/CallToActionSection";
import { Services } from "@/components/Services";
import { Testimonials } from "@/components/Testimonials";
import { Coupons } from "@/components/Coupons";
import { ProjectGallery } from "@/components/ProjectGallery";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { FAQ } from "@/components/FAQ";

const Index = () => {
  return (
    <main className="min-h-screen">
      <SEOHead 
        canonical="https://quote.safewayroofingandchimney.com/"
      />
      <Header />
      <Hero />
      <RecentProjects />
      <TrustBadges />
      <CallToActionSection />
      <Services />
      <Testimonials />
      <FAQ />
      <Coupons />
      <ProjectGallery />
      <Footer />
    </main>
  );
};

export default Index;
